import { LockResetOutlined, LogoutOutlined } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import { authBusiness } from "api/bussiness/auth/auth-business";
import { observer } from "mobx-react-lite";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useStores } from "../../../mobx-stores/_root-store";
import { XButton } from "../../../share-components/mui-wrap/button/x-button";
import { ProfileAvatar } from "./avatar";
type ProfileMenuContentProps = {
  onChangePwHandler?: () => void;
};
export const ProfileMenuContent = observer(
  ({ onChangePwHandler }: ProfileMenuContentProps) => {
    const {
      authentication: { profile, setProp },
    } = useStores();
    const navigate = useNavigate();
    const onLogoutClick = useCallback(async () => {
      await authBusiness.logout();
      navigate("/", { replace: true });
    }, [navigate]);

    const onChangePWHandler = useCallback(() => {
      onChangePwHandler?.();
      setProp("openChangePw", true);
    }, [onChangePwHandler, setProp]);
    return (
      <Stack direction={"row"} spacing={2}>
        <Stack>
          <ProfileAvatar></ProfileAvatar>
        </Stack>
        <Stack direction={"column"} spacing={3}>
          <Box>
            <Typography variant="body1">{profile?.name}</Typography>
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              {profile?.userName}
            </Typography>
          </Box>

          <Box>
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              {profile?.phoneNumber}
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              {profile?.email}
            </Typography>
          </Box>

          <Stack spacing={2} direction={"row"} alignItems={"center"}>
            <XButton
              variant="text"
              endIcon={<LogoutOutlined></LogoutOutlined>}
              onClick={onLogoutClick}
            >
              Đăng xuất
            </XButton>
            <XButton
              variant="text"
              onClick={onChangePWHandler}
              endIcon={<LockResetOutlined></LockResetOutlined>}
            >
              Đổi mật khẩu
            </XButton>
          </Stack>
        </Stack>
      </Stack>
    );
  }
);
